import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    FormularioGetModel,
    FormularioListModel,
    FormularioPostModel,
    FormularioPreenchidoGetModel,
    FormularioPreenchidoListModel,
    FormularioPreenchidoPostModel,
    ModeloFormularioGetModel,
    ModeloFormularioListModel
} from "app/models/formulario.model";
import { PaginacaoModel, ResultadoPaginado } from "app/models/paginacao.model";
import { RespostaPadrao } from "app/models/resposta-padrao.model";
import { environment } from "environments/environment";
import { Observable, firstValueFrom } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class FormularioService {
    constructor(private httpClient: HttpClient) { }

    // ===== Formulários =====

    adicionar(formulario: FormularioPostModel): Observable<RespostaPadrao> {
        return this.httpClient.post<RespostaPadrao>(`${environment.urlApi}/Formulario/adicionar`, formulario);
    }

    atualizar(formulario: FormularioPostModel): Observable<RespostaPadrao> {
        return this.httpClient.post<RespostaPadrao>(`${environment.urlApi}/Formulario/atualizar`, formulario);
    }

    async obterPorId(formularioId: number): Promise<FormularioGetModel> {
        return firstValueFrom(
            this.httpClient.get<FormularioGetModel>(`${environment.urlApi}/Formulario/obter/${formularioId}`)
        );
    }

    async obterPorUsuario(paginacao: PaginacaoModel): Promise<ResultadoPaginado<FormularioListModel>> {
        let params = new HttpParams()
            .set('pagina', paginacao.pagina)
            .set('tamanhoPagina', paginacao.tamanhoPagina)
            .set('ordenarPor', paginacao.ordenarPor)
            .set('descendente', paginacao.descendente);
        if (paginacao.pesquisa) params = params.set('pesquisa', paginacao.pesquisa);
        return firstValueFrom(
            this.httpClient.get<ResultadoPaginado<FormularioListModel>>(`${environment.urlApi}/Formulario/obterPorUsuario`, { params })
        );
    }

    async obterFormulariosAtivos(): Promise<FormularioListModel[]> {
        return firstValueFrom(
            this.httpClient.get<FormularioListModel[]>(`${environment.urlApi}/Formulario/obterAtivos`)
        );
    }

    duplicar(formularioId: number): Observable<RespostaPadrao> {
        return this.httpClient.post<RespostaPadrao>(`${environment.urlApi}/Formulario/duplicar/${formularioId}`, {});
    }

    remover(formularioId: number): Observable<RespostaPadrao> {
        return this.httpClient.delete<RespostaPadrao>(`${environment.urlApi}/Formulario/remover/${formularioId}`);
    }

    // ===== Modelos =====

    async obterModelos(): Promise<ModeloFormularioListModel[]> {
        return firstValueFrom(
            this.httpClient.get<ModeloFormularioListModel[]>(`${environment.urlApi}/Formulario/modelos`)
        );
    }

    async obterModelo(modeloId: number): Promise<ModeloFormularioGetModel> {
        return firstValueFrom(
            this.httpClient.get<ModeloFormularioGetModel>(`${environment.urlApi}/Formulario/modelos/${modeloId}`)
        );
    }

    criarDeModelo(modeloId: number, nome?: string): Observable<RespostaPadrao> {
        let params = new HttpParams();
        if (nome) params = params.set('nome', nome);
        return this.httpClient.post<RespostaPadrao>(`${environment.urlApi}/Formulario/criarDeModelo/${modeloId}`, {}, { params });
    }

    // ===== Preenchidos =====

    adicionarPreenchido(preenchido: FormularioPreenchidoPostModel): Observable<RespostaPadrao> {
        return this.httpClient.post<RespostaPadrao>(`${environment.urlApi}/FormularioPreenchido/adicionar`, preenchido);
    }

    atualizarPreenchido(preenchido: FormularioPreenchidoPostModel): Observable<RespostaPadrao> {
        return this.httpClient.post<RespostaPadrao>(`${environment.urlApi}/FormularioPreenchido/atualizar`, preenchido);
    }

    async obterPreenchido(preenchidoId: number): Promise<FormularioPreenchidoGetModel> {
        return firstValueFrom(
            this.httpClient.get<FormularioPreenchidoGetModel>(`${environment.urlApi}/FormularioPreenchido/obter/${preenchidoId}`)
        );
    }

    async obterPreenchidosPorCliente(clienteId: number): Promise<FormularioPreenchidoListModel[]> {
        return firstValueFrom(
            this.httpClient.get<FormularioPreenchidoListModel[]>(`${environment.urlApi}/FormularioPreenchido/obterPorCliente/${clienteId}`)
        );
    }

    removerPreenchido(preenchidoId: number): Observable<RespostaPadrao> {
        return this.httpClient.delete<RespostaPadrao>(`${environment.urlApi}/FormularioPreenchido/remover/${preenchidoId}`);
    }
}
